import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'geography-ready-launch-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const storedDeadline = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(storedDeadline) && storedDeadline > Date.now() ? storedDeadline : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const updateTimer = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      });
    };
    updateTimer();
    const interval = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <aside className="sticky top-0 z-50 flex h-8 w-full items-center justify-center bg-brand-blue px-2 text-white shadow-sm" data-id="element-34" data-mp="uedugac2g6q9">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-35" data-mp="yf7hl1hophi3">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-36" data-mp="1m48lcbfko4h1">
          <span className="sm:hidden" data-id="element-37" data-mp="1r3uwmfbuban7">🌍 GEOGRAPHY READY</span>
          <span className="hidden sm:inline" data-id="element-38" data-mp="1r5frk622gvll">🌍 GEOGRAPHY READY · THE COMPLETE SECONDARY GEOGRAPHY CURRICULUM</span>
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`${timeLeft.hours} hours, ${timeLeft.minutes} minutes, ${timeLeft.seconds} seconds remaining`} data-id="element-39" data-mp="1hd9zkwbtee6e">
          <TimerUnit value={timeLeft.hours} label="HRS" data-id="element-40" data-mp="251jgpky32dr7" />
          <span className="text-xs font-bold" data-id="element-41" data-mp="29uw7a0mbouml">:</span>
          <TimerUnit value={timeLeft.minutes} label="MIN" data-id="element-42" data-mp="2jq35fdan357h" />
          <span className="text-xs font-bold" data-id="element-43" data-mp="2jpjlxs5cc8rc">:</span>
          <TimerUnit value={timeLeft.seconds} label="SEC" data-id="element-44" data-mp="2fnyckgs0mclw" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-45" data-mp="25qk6nb3px67u">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-46" data-mp="20rh0tofwyvyt">{label}</span>
    </span>;
}